import { lazy } from "react";

const Interview = lazy(() => import("../Component/Interview/Interview"));
const InterviewAssessmentForm = lazy(() => import("../Component/Interview/AssessmentPDF"));
const AssessmentPDF = lazy(() => import("../Component/Interview/AssessmentPDF"));
const RecommendedFeedback = lazy(() => import("../Component/Recommendation/RecommendedFeedback"));
const NonRecommendedFeedback = lazy(() =>
  import("../Component/Recommendation/NonRecommendedFeedback")
);
const HoldforFurtherEvaluation = lazy(() =>
  import("../Component/Recommendation/HoldforFurtherEvaluation")
);
const InterviewDetails = lazy(() => import("../Component/Recommendation/InterviewDetails"));
const AllAcceptedOffers = lazy(() => import("../Component/Recommendation/AllAcceptedOffers"));
const Feedback = lazy(() => import("../Component/Interview/Feedback"));

const interviewRoutes = [
  { path: "/manage-interview-list", element: <Interview />, protected: true },
  {
    path: "/interviewers-recommendation-pdf",
    element: <InterviewAssessmentForm />,
    protected: true,
  },
  { path: "/candidate-feedback-detail/:id", element: <AssessmentPDF />, protected: true },
  { path: "/recommended-feedback", element: <RecommendedFeedback />, protected: true },
  { path: "/non-recommended-feedback", element: <NonRecommendedFeedback />, protected: true },
  {
    path: "/hold-for-further-evaluation",
    element: <HoldforFurtherEvaluation />,
    protected: true,
  },
  { path: "/interview-details/:id", element: <InterviewDetails />, protected: true },
  { path: "/accepted-offer-letter", element: <AllAcceptedOffers />, protected: true },
  { path: "/feedback", element: <Feedback />, protected: true },
];

export default interviewRoutes;
